/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface TagChangeDataSampler
 *
 */
// create custom validators for the regexes
export interface TagChangeDataSampler {
    /**
     *
     * #type string
     * #memberof TagChangeDataSampler
        
        
         */
    method: string;
}
/**
 * Check if a given object implements the TagChangeDataSampler interface.
 */
export function instanceOfTagChangeDataSampler(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const TagChangeDataSamplerTypiaAssertEquals = (input: any) => {
    return ((input: any): TagChangeDataSampler => {
        const __is = (input: any, _exceptionable: boolean = true): input is TagChangeDataSampler => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.method && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["method"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TagChangeDataSampler => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "string",
                    value: input.method
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["method"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataSampler",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataSampler",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const TagChangeDataSamplerTypiaAssertStringify = (input: TagChangeDataSampler): string => {
    return ((input: any): string => { const assert = (input: any): TagChangeDataSampler => {
        const __is = (input: any): input is TagChangeDataSampler => {
            return "object" === typeof input && null !== input && "string" === typeof (input as any).method;
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TagChangeDataSampler => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => "string" === typeof input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "string",
                    value: input.method
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataSampler",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataSampler",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: TagChangeDataSampler): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"method":${$string((input as any).method)}}`;
    }; return stringify(assert(input)); })(input);
};
export const TagChangeDataSamplerValidatorShape = {
    'method': yup.string().defined(),
};
export const TagChangeDataSamplerValidator = yup.object().shape(TagChangeDataSamplerValidatorShape);
export const TagChangeDataSamplerStringifyShapeProperties: ObjectSchema['properties'] = {
    'method': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const TagChangeDataSamplerStringifyShape: ObjectSchema = {
    title: 'TagChangeDataSampler Stringifier',
    type: 'object',
    properties: {
        ...TagChangeDataSamplerStringifyShapeProperties
    },
    required: [
        'method',
    ],
};
export const TagChangeDataSamplerStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(TagChangeDataSamplerStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const TagChangeDataSamplerStringify: (data: TagChangeDataSampler) => string = TagChangeDataSamplerStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function TagChangeDataSamplerFromJSON(json: any): TagChangeDataSampler {
    return TagChangeDataSamplerFromJSONTyped(json, false);
}
export function TagChangeDataSamplerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagChangeDataSampler {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'method': json['method'],
    };
}
export function TagChangeDataSamplerToJSON(value?: TagChangeDataSampler | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'method': value.method,
    };
}
